<template>
  <div class="countrySettings" v-if="showComponent">
    <div class="inputSelect --tag  --sm"
         v-if="hasCountrySettings"
    >
    <!-- <span class="inputSelect__label" for="basic-url">{{ $t('country_settings') }}*</span> -->
      <div class="inputSelect__group">
        <select
          class="inputSelect__input"
          ref="countrySettings"
          id="search-form__select-currency"
          @change="change"
          v-model="country"
        >
          <option
            v-for="option in countrySettingEnable"
            :value="option.id"
            :key="option.id"
          >
            {{ getOptionTranslated(option) }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountrySettings',
  props: {
    countrySettings: { required: true },
    value: { required: false, default: '' },
    fixedPos: { required: false }
  },
  computed: {
    hasCountrySettings: function () {
      return this.countrySettings.length
    },
    countrySettingEnable: function () {
      let countrySettingEnable = []
      if (this.fixedPos === 0) {
        countrySettingEnable = this.countrySettings.filter(x => x.enable)
      } else {
        this.country = this.fixedPos
        countrySettingEnable = this.countrySettings.filter(x => x.enable && x.id === this.fixedPos)
      }
      if (this.posIdList) {
        // Enable only country settings sent by query param
        let CountrySettingFilteredByPosId = countrySettingEnable.filter(x => this.posIdList.includes(x.id))
        if (CountrySettingFilteredByPosId.length == 0 ||
            this.posIdList.length > 1 && CountrySettingFilteredByPosId.length == 1) {
          // If there is no valid pos sent, we set the default
          return countrySettingEnable
        } else {
          return CountrySettingFilteredByPosId
        }
      } else {
        return countrySettingEnable
      }
    },
    setCountryByPosId: function() {
      let countrySettingsEnabledIds = []
      // Filter ids by country settings enabled
      for (let i = 0; i < this.countrySettingEnable.length; i++) {
        let enabledId = this.countrySettingEnable[i].id
        countrySettingsEnabledIds.push(enabledId)
      }
      let firstEnabledPosId
      if(this.posIdList) {
        let posIdListFilteredByOrder = this.posIdList.filter(function(item) {
          return countrySettingsEnabledIds.includes(item);
        })
        // E.g.: cs_enabled=3,4 - &pos=20,3,29,4 - filtered=3,4 - firstEnabledPosId=3
        firstEnabledPosId = posIdListFilteredByOrder[0]
      }  
      if (!firstEnabledPosId && this.fixedPos === 0){
        return !this.value ? this.countrySettingEnable.filter(
            x=> x.default===true)[0].id : this.value.id
      } else if (!firstEnabledPosId && this.fixedPos !== 0){
        return this.fixedPos 
      } else {
        return firstEnabledPosId
      }
    },
    showComponent: function () {
      let show = 0
      if (this.countrySettingEnable.length > 1 || (this.posIdList && this.posIdList.length > 1)) {
        show = 1
      }
      return show
    }
  },
  data () {
    return {
      country: null
    }
  },
  methods: {
    change: function () {
      const country = this.countrySettingEnable.find(x => x.id === this.country)
      if (country && country.id !== this.value?.id) {
        this.$emit('input', country)
      }
    },
    getOptionTranslated: function (option) {
      const label = `description_${option.iso_country_code}_${option.currency_code}_${option.device_id}`
      return !this.$t(label) ? label: this.$t(label)
    },
  },
  created () {
    this.posId = this.$store.getters.getPosId.posId
    if (this.posId) {
      this.posIdList = this.posId.split(',').map(Number)
      this.country = this.setCountryByPosId
    } else {
      this.country = !this.value ? this.countrySettingEnable.filter(
          x=> x.default===true)[0].id : this.value.id
    }
    this.change()
  },
  beforeUpdate () {
    this.posId = this.$store.getters.getPosId.posId
    if (this.posId) {
      this.posIdList = this.posId.split(',').map(Number)
      this.country = this.setCountryByPosId
    } else {
      this.country = !this.value ? this.countrySettingEnable.filter(
          x=> x.default===true)[0].id : this.value.id
    }
    this.change()
  }
}
</script>
